<template>
	<div>
		<div class="content" id="sorting">
			<p>
				Sorting is enabled per column through the <code>sortProp</code> and <code>sortable</code> properties, or disabled globally with <code>sortDisabled</code> property.<br>
				Property <code>prop</code> is used if <code>sortProp</code> is undefined, null or an empty string.<br>
				By default the table is configured to sort one column at a time, but with the <code>multisort</code> property you can change this behavior:
			</p>
			<pre v-highlightjs class="box pa-0"><code class="html">&lt;ui-table :items=&quot;items&quot; :sort-disabled=&quot;sortDisabled&quot; :multisort=&quot;multisort&quot; striped&gt;
	&lt;ui-table-column prop=&quot;group&quot; sortable/&gt;
	&lt;ui-table-column prop=&quot;user&quot; sortable/&gt;
	&lt;ui-table-column prop=&quot;age&quot; sortable/&gt;
&lt;/ui-table&gt;</code></pre>
		</div>
		<div class="box">
			<div class="level">
				<div class="level-item">
					<label class="checkbox">
						<input type="checkbox" v-model="sortDisabled">
						disable sort
					</label>
				</div>
				<div class="level-item">
					<label class="checkbox">
						<input type="checkbox" v-model="multisort">
						multisort
					</label>
				</div>
			</div>
			<ui-table :items="items" :sort-disabled="sortDisabled" :multisort="multisort" striped>
				<ui-table-column prop="group" sortable/>
				<ui-table-column prop="user" sortable/>
				<ui-table-column prop="age" sortable/>
			</ui-table>
		</div>
	</div>
</template>

<script>
    export default {
        name: "sorting",
		data() {
            return {
                sortDisabled: false,
				multisort: false,
                items: [
                    { group: "foo", user: "User 1", age: 44 },
                    { group: "bar", user: "User 2", age: 21 },
                    { group: "foo", user: "User 3", age: 33 },
                    { group: "foo", user: "User 4", age: 37 },
                    { group: "bar", user: "User 5", age: 55 },
                    { group: "foo", user: "User 6", age: 18 },
                    { group: "bar", user: "User 7", age: 25 },
                    { group: "bar", user: "User 8", age: 61 },
                    { group: "bar", user: "User 9", age: 44 },
                    { group: "bar", user: "User 10", age: 21 }
                ]
			}
		}
    }
</script>